<app-dialog
  [title]="data.title"
  [actions]="actions"
  [hideCloser]="data.disableClose"
  (action)="close($event)"
  (close)="close()"
>
  <div class="confirm" [innerHTML]="data.message"></div>
  <div  *ngIf="data.warning" class="font-12" [innerHTML]="data.warning"><i class="far fa-exclamation-triangle me-2"></i></div>
</app-dialog>
